<script>
import styled from "vue-styled-components";

const CookieBannerWrapper = styled.div`
  position: relative;
  overflow: hidden;
  height: 100%;
`;

export default CookieBannerWrapper;
</script>
